import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import App from "./App";
var container = document.getElementById('app');
var root = createRoot(container); // The '!' tells TS the element exists
root.render(_jsx(App, {}));
